'use strict';

import React, { Component, Fragment } from 'react';
import is from 'is_js';
import TextInput from 'Components/Forms/Elements/TextInput';
import Switch from 'Components/Forms/Elements/Switch';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import getStateFromObject from 'Components/Forms/Functions/getStateFromObject';
import getFormData from 'Components/Forms/Functions/getFormData';
import bemit from 'Functions/bemit';
import Loader from 'Pure/Loader';
import { action } from 'Shared/Routes';
let app = window.app;
const qwest = window.qwest;
export default class UserForm extends Component {
  state = {
    status_messages: {},
    "user[roles]": []
  };
  handleChange = handleChange.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.fetchUser();
    }
  }
  fetchUser = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('getAllUsers'), {
      id: props.id || document.location.pathname.split('/liste-des-utilisateurs/')[1],
      with_count: false
    }).then(function (xhr, response) {
      const user_roles = response.data[0].roles;
      delete response.data[0].roles;
      const update = getStateFromObject({
        data: response.data[0],
        model: 'user'
      });
      component.setState({
        ...update,
        "user[roles]": user_roles,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
    component.setState({});
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const user = getFormData({
      state: state,
      pattern: 'user['
    });
    const url = props.type === 'update' ? action('UpdateUser') : '/user/create';
    qwest.post(url, user).then(function (xhr, response) {
      if (props.type === 'update') {
        component.fetchUser();
      } else {
        component.clearForm();
        if (app.state.session?.user?.id === response.updated_id) {
          Object.assign(app.state.session.user, response.update || {});
          if (response.sha_256_email) {
            app.state.session.sha_256_email = response.sha_256_email;
          }
        }
        window.setTimeout(function () {
          app.navigateTo('/liste-des-utilisateurs');
        }, 2000);
      }
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handleRadioChange = event => {
    const component = this,
      props = this.props,
      state = this.state;
    const target = event.target;
    const value = target.value;
    const name = target.name;
    component.setState({
      [name]: [value],
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  clearForm = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const update = Object.keys(state).filter(key => key.startsWith('user[')).reduce(function (update, key) {
      if (is.string(state[key])) {
        update[key] = '';
      } else if (is.array(state[key])) {
        update[key] = [];
      } else if (is.json(state[key])) {
        update[key] = {};
      }
      return update;
    }, {});
    component.setState(update);
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = getFormStatus(state);
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let output = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("form", {
      method: "POST",
      action: "/user/create",
      className: props.paper !== false ? 'c-paper' : undefined
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['user[login]'],
      name: "user[login]",
      type: "text",
      label: "E-mail (login)",
      autocomplete: "new-email",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['user[password]'],
      name: "user[password]",
      type: "password",
      label: "Mot de passe",
      autocomplete: "new-password",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['user[lastname]'],
      name: "user[lastname]",
      label: "Nom",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['user[firstname]'],
      name: "user[firstname]",
      label: "Pr\xE9nom",
      status: state.status_messages
    })), /* (state['user[roles]'] || []).includes('admin') && */
    app.state.session?.user?.super_admin ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2,
      className: "u-margin-top-15 u-margin-bottom-15"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 2,
      className: "u-flex u-items-center"
    }, /*#__PURE__*/React.createElement(Radio, {
      checked: state["user[roles]"].includes("admin"),
      onChange: component.handleRadioChange,
      value: "admin",
      color: "primary",
      name: "user[roles]"
    }), "Admin"), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 2,
      className: "u-flex u-items-center"
    }, /*#__PURE__*/React.createElement(Radio, {
      checked: state["user[roles]"].includes("marketing"),
      onChange: component.handleRadioChange,
      value: "marketing",
      color: "primary",
      name: "user[roles]"
    }), "Marketing"), state["user[roles]"].includes("admin") ? /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: component.handleChange,
      value: state['user[super_admin]'],
      name: "user[super_admin]",
      label: "Super admin",
      status: state.status_messages
    })) : undefined, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: component.handleChange,
      value: state['user[can_export_data]'],
      name: "user[can_export_data]",
      label: "Peut exporter les donn\xE9es",
      status: state.status_messages
    })))) : undefined), status), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-text-center\r u-margin-top-25 u-padding-bottom-20 "
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.validate
    }, props.type === 'update' ? 'Mettre à jour' : 'Créer cet utilisateur', loader)));
    return output;
  }
}
